import { IRegistrationKiwiSaverEntityState, RegistrationKiwiSaverState } from './../../state/registration-kiwisaver.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Features } from 'src/app/models/features';

export const getRegistrationKiwiSaverState = createFeatureSelector<RegistrationKiwiSaverState>(Features.REGISTRATION_KIWISAVER);

export const selectRegistrationKiwiSaverEntityState = createSelector(
    getRegistrationKiwiSaverState,
    (state: RegistrationKiwiSaverState) => state.kiwiSaverEntity
);

export const selectRegistrationKiwiSaverFailText = createSelector(
    getRegistrationKiwiSaverState,
    (state: RegistrationKiwiSaverState) => state.kiwiSaverStatus.failText
);

export const selectRegistrationKiwiSaverStatus = createSelector(
    getRegistrationKiwiSaverState,
    (state: RegistrationKiwiSaverState) => state.kiwiSaverStatus.status
);

export const selectRegistrationKiwiSaverEntityId = createSelector(
    selectRegistrationKiwiSaverEntityState,
    (state: IRegistrationKiwiSaverEntityState) => state.entityId
);

